export const NAMESPACE = "EditQuestionSetQuestionsModal";

export const HEIGHTS = {
  HEADER: 64,
  FOOTER: 80
};
